// Stable Campaign presentation/domain error categories — the small vocabulary
// every capability port rejects with, whether fixture-backed or HTTP-backed.
// HTTP mapping (status codes, Axios error shapes, response envelopes) lives in
// the adapter layer (`adapters/campaign-http-error.ts`), never here — this
// module stays transport-neutral so no page or component ever changes when a
// port's transport does.

/** The six stable categories every Campaign capability rejection carries. */
export type CampaignErrorCategory =
	| 'not-found'
	| 'forbidden'
	| 'validation'
	| 'invalid-transition'
	| 'conflict'
	| 'failure'

/** A rejection from a Campaign capability port — category plus a display message. */
export class CampaignError extends Error {
	readonly category: CampaignErrorCategory
	/** The offending field, for the `validation` category. */
	readonly field?: string

	constructor(category: CampaignErrorCategory, message: string, field?: string) {
		super(message)
		this.name = 'CampaignError'
		this.category = category
		this.field = field
	}
}

export function isCampaignError(error: unknown): error is CampaignError {
	return error instanceof CampaignError
}
